export default "__VITE_ASSET__C$Q57nYl__"